module.exports = __webpack_public_path__ + "static/media/guide_reversal_1_sp.ff4b1127.svg";